export default {
  data() {
    return {
      typing_timeout: null,
      typing_interval: 500,
      typing_is_typing: false,
      local_callback: () => {}
    }
  },
  methods: {
    /**
     * Make longer(shorter) interval between callback call
     * @param typing_interval
     */
    setTypingInterval(typing_interval = 500) {
      this.typing_interval = typing_interval
    },
    typing(callback) {
      this.typing_is_typing = true
      this.local_callback = callback
      if (this.typing_timeout) clearTimeout(this.typing_timeout)
      this.typing_timeout = setTimeout(this.localCallback, this.typing_interval)
    },
    localCallback() {
      this.typing_is_typing = false
      this.local_callback()
    }
  }
}
